import { UpdateLocaleCookie } from 'types/messages/incoming';
import { MiddlewareAPI } from 'types/redux';

export default function updateLocaleCookie(store: MiddlewareAPI, message: UpdateLocaleCookie) {
  store.dispatch({
    data: message.data,
    type: '@@config/UPDATE_LOCALE_COOKIE'
  });
}
